import { render, staticRenderFns } from "./VacancyChat.htm?vue&type=template&id=661f0ffc&scoped=true&"
import script from "./VacancyChat.ts?vue&type=script&lang=js&"
export * from "./VacancyChat.ts?vue&type=script&lang=js&"
import style0 from "./VacancyChat.scss?vue&type=style&index=0&id=661f0ffc&lang=scss&scoped=true&"
import style1 from "./VacancyChatLayout.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f0ffc",
  null
  
)

export default component.exports